import { emailRegExp, isOver18Years, trimText } from 'utils';
import { isFuture } from 'date-fns';
import localization from '../localization';
import { validatePhoneNum, validateSsn, validateName } from '../utils';

const phoneError = {
  isValid: (_, occupant) => validatePhoneNum(trimText(occupant.homePhone)) || validatePhoneNum(trimText(occupant.workPhone)) || validatePhoneNum(trimText(occupant.cellPhone)),
  message: (lang) => localization[lang].occupant_errors.phone
};

export default {
  name: {
    isValid: (name) => validateName(name),
    message: (lang) => localization[lang].common_errors.name
  },
  ssn: {
    isValid: (ssn) => validateSsn(ssn),
    message: (lang) => localization[lang].occupant_errors.ssn
  },
  email: {
    isValid: (email) => emailRegExp(trimText(email)),
    message: (lang) => localization[lang].common_errors.valid_email
  },
  dob: {
    isValid: (dob, occupant) => occupant.dob && !isFuture(dob) && (isOver18Years(dob) || occupant.status !== 'leaseholder'),
    message: (lang, occupant) => {
      if (!occupant.dob) return localization[lang].occupant_errors.no_date;
      if (isFuture(occupant.dob)) return localization[lang].occupant_errors.future_date;
      return `${localization[lang].occupant_errors.leaseholder_dob} ${window?.MINIMUM_AGE || 18}`;
    }
  },
  homePhone: phoneError,
  workPhone: phoneError,
  cellPhone: phoneError
};

